import {useAppStore} from "@/stores/appStore";
import type {App} from "vue";
import type {Options} from "@vitejs/plugin-vue";
import {
    AddressesApi, Configuration, CustomersApi,
    LogsApi,
    ModulesSettingsApi,
    OrderItemsApi,
    OrdersApi, ProductsApi,
    ProjectsApi,
    SpacesApi,
    UsersApi
} from "@haxo-cz/orders-ts-client";



declare global {
    interface ImportMeta {
        env: Record<string, unknown>;
    }
}
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $spacesApi: SpacesApi;
        $projectsApi: ProjectsApi;
        $usersApi: UsersApi;
        $modulesSettingsApi: ModulesSettingsApi;
        $logsApi: LogsApi;
        $ordersApi: OrdersApi;
        $orderItemsApi: OrderItemsApi;
        $addressesApi: AddressesApi;
        $customersApi: CustomersApi;
        $productsApi: ProductsApi;

    }
}


export default {
    async install(app : App , options : Options) {
        /**
         * vrací true pokud se managers inicializovaly jinak error
         */
        app.config.globalProperties.$apisReady = new Promise(async (resolve, reject) => {
            try {
                const appStore = useAppStore();
                console.log('plugin is authenticated', appStore.isAuthenticated);
                if(!appStore.isAuthenticated)
                    return resolve(false);
                let token: string;
                try {
                    token = await appStore.auth0.getAccessTokenSilently();
                } catch (err: any) {
                    if (err?.error === 'missing_refresh_token' || /Missing Refresh Token/.test(err?.message ?? '')) {
                        await appStore.auth0.loginWithRedirect();
                        return resolve(false);
                    }
                    throw err;
                }
                if (token) {
                    const params = {
                        apiKey: async () => 'Bearer ' + await appStore.auth0.getAccessTokenSilently(),
                        basePath: import.meta.env.VITE_API_URL as string
                    }
                    const apiConfiguration = new Configuration(params);

                    app.config.globalProperties.$spacesApi = new SpacesApi(apiConfiguration);
                    app.config.globalProperties.$projectsApi = new ProjectsApi(apiConfiguration);
                    app.config.globalProperties.$usersApi = new UsersApi(apiConfiguration);
                    app.config.globalProperties.$modulesSettingsApi = new ModulesSettingsApi(apiConfiguration);
                    app.config.globalProperties.$logsApi = new LogsApi(apiConfiguration);
                    app.config.globalProperties.$ordersApi = new OrdersApi(apiConfiguration);
                    app.config.globalProperties.$orderItemsApi = new OrderItemsApi(apiConfiguration);
                    app.config.globalProperties.$addressesApi = new AddressesApi(apiConfiguration);
                    app.config.globalProperties.$customersApi = new CustomersApi(apiConfiguration);
                    app.config.globalProperties.$productsApi = new ProductsApi(apiConfiguration);
                    console.log("api ready");
                    resolve(true);
                } else {
                    reject(new Error('No token available'));
                }
            } catch (error) {
                reject(error);
            }
        });
    }
};